<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef" :menuUrl="'conversations'"></sideBar>
				<div class="v-content-white-wrapper">
					<div class="conversation-details-container">
						<template v-if="productInfos.storeMessageNo">
							<div class="conversation-details-header">
								<h1 class="conversation-details-title">query with  
									<span class="conversation-details-shop">{{productInfos.memberName}}</span>
								</h1>
							</div>
							<div class="conversation-details-card">
								<h4 class="conversation-details-card-title">{{productInfos.productName}}</h4>
								<div class="conversation-load-more" v-if="lists.length < totalNum" @click="loadMore">
									<i class="el-icon-loading load-more-btn" v-if="isMoreLoading"></i>
									<i class="el-icon-refresh-right load-more-btn" v-else></i>
								</div>
								<div class="conversation-details-messages">
									<div class="conversation-details-message conversation-details-message-border">
										<div class="conversation-details-message-header">
											<div class="conversation-details-avatar" style="height: 48px; min-width: 48px; width: 48px;">
												<img :src="productInfos.memberImg" class="conversation-details-avatar-img"/>
											</div>
											<div class="conversation-details-user-info">
												<h5 class="conversation-details-user-name">{{productInfos.memberName}}</h5>
												<div class="conversation-details-message-time">{{productInfos.createTime}}</div>
											</div>
										</div>
										<div class="conversation-details-message-content">
											<div class="mt-2">
												<div class="product-card">
													<div class="d-flex">
														<div class="product-image">
															<img :src="productInfos.productPhoto" class="image-products"/>
														</div>
														<div class="product-info pa-3">
															<h3 class="product-title font-weight-bold mb-1">{{productInfos.productName}}</h3>
															<p class="product-price font-weight-bold primary--text">${{productInfos.productPrice}}</p>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="conversation-details-message conversation-details-message-border" v-for="(item,index) in lists" :key="index">
										<div class="conversation-details-message-header ">
											<div class="conversation-details-avatar" style="height: 48px; min-width: 48px; width: 48px;">
												<img :src="item.memberHead" v-if="item.userType == 1" class="conversation-details-avatar-img"/>
												<img :src="item.storePhoto" v-else class="conversation-details-avatar-img"/>
											</div>
											<div class="conversation-details-user-info">
												<h5 class="conversation-details-user-name">{{item.userType == 1 ? item.memberName : item.storeName}}</h5>
												<div class="conversation-details-message-time">{{item.createTime}}</div>
											</div>
										</div>
										<div class="conversation-details-message-content">
											<template v-if="item.msgtype == 2">
												<div class="conversation-details-message-image">
													<el-image :src="item.imgUrl" :preview-src-list="[item.imgUrl]" class="conversation-details-image"></el-image>
												</div>
											</template>
											<template v-else>
												<div class="conversation-details-message-text">{{item.content}}</div>
											</template>
											
										</div>
									</div>
								</div>
								<div class="conversation-details-reply">
									<div class="v-form">
										<div class="conversation-details-form-group">
											<div class="conversation-details-form-label">Message</div>
											<div class="conversation-details-textarea">
												<div class="v-input__control">
													<div class="v-input__slot">
														<div class="v-text-field__slot">
															<textarea v-model="content" placeholder="Message" rows="4"></textarea>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="conversation-details-actions">
											<div class="conversation-details-image-btn">
												<input style="width:100%;height:100%;opacity:0;position: absolute;top:0;left:0;z-index: 2;cursor: pointer;" type="file" accept="image/*" @change="onFileChange" />
												Send Image
											</div>
											<div class="conversation-details-send-btn" @click="sendMessage()">Send</div>
										</div>
									</div>
								</div>
							</div>
						</template>
						<template v-else>
							<div style="width: 100%;margin-top: 30px;height: auto;">
								<empty></empty>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>
		<tabBar ref="tabBarRef"></tabBar>
	</div>
</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import empty from '../../components/empty.vue'
	import { getStoreMessagedtl, quernewmsg, continueProductMessage } from "@/api/message";
	import {uploadFile} from '../../api/home'
	export default {
		components: {
			headerNav,
			sideBar,
			tabBar,
			empty
		},
		data() {
			return {
				isMoreLoading:false,
				lists:[],
				currentPage:1,
				pageSize:10,
				storeMessageNo:'',
				lastId:'',
				productInfos:{},
				totalNum:0,
				loadTimer:null,
				content:'',
				imgUrl:'',
				selectedFile:null
			}
		},
		created() {
			this.storeMessageNo = this.$route.query.no
			this.getMessageList();
		},
		beforeUnmount() {
			clearInterval(this.loadTimer)
			this.loadTimer = null
		},
		beforeDestroy() {
			clearInterval(this.loadTimer)
			this.loadTimer = null
		},
		methods: {
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
				this.$refs.tabBarRef.handleBrage()
			},
			getMessageList() {
				var that = this
				var params = {
					storeMessageNo: this.storeMessageNo,
					page: this.currentPage,
					pageSize: this.pageSize
				}
				getStoreMessagedtl(params).then(res => {
					this.isMoreLoading = false
					if (res.code == 200) {
						if(this.currentPage > 1){
							this.lists = [...res.data.list.reverse(),...this.lists];
						}else{
							this.productInfos = res.data.bo
							if(res.data.list.length > 0){
								this.lists = res.data.list.reverse();
								that.lastId = that.lists[that.lists.length - 1].id
							}
							this.totalNum = res.data.total
							this.loadNew()
						}
					}
				})
			},
			loadMore(){
				this.currentPage = this.currentPage + 1
				this.isMoreLoading = true
				this.getMessageList()
			},
			getNew(){
				var that = this
				var params = {
					storeMessageNo: this.storeMessageNo,
					page: this.currentPage,
					pageSize: this.pageSize,
					id:this.lastId
				}
				quernewmsg(params).then(res => {
					this.isMoreLoading = false
					if (res.code == 200) {
						if(res.data.length > 0){
							this.lists = [...this.lists,...res.data.reverse()];
							that.lastId = that.lists[that.lists.length - 1].id
						}
					}
				})
			},
			loadNew(){
				var that = this
				this.loadTimer = setInterval(()=>{
					that.getNew()
				},3000)
			},
			onFileChange(e) {
				this.selectedFile = e.target.files[0];
				this.uploadPhoto(1)
			},
			onFileChange(e) {
				this.selectedFile = e.target.files[0];
				this.uploadPhoto()
			},
			uploadPhoto() {
				// 上传到服务器
				const formData = new FormData();
				formData.append('file', this.selectedFile, this.selectedFile.name);
				let file = formData
				uploadFile(file).then(res => {
					if (res.code == 200) {
						this.imgUrl = res.url;
						this.sendMessage()
					} else {
						this.$message.error(res.msg || 'Image upload failed');
					}
				}).catch(err => {
					this.$message.error(err.msg || 'Image upload failed');
				});
			},
			sendMessage() {
				if(this.content || this.imgUrl){
					var that = this
					var params = {
						storeMessageNo: this.storeMessageNo,
						content: this.content,
						imgUrl: this.imgUrl
					}
					const loading = this.$loading({
					    lock: true,
					    text: 'Loading',
					    spinner: 'el-icon-loading',
					    background: 'rgba(0, 0, 0, 0.2)'
					});
					that.content = ''
					that.imgUrl = ''
					continueProductMessage(params).then(res => {
						loading.close();
						if (res.code == 200) {
							if(res.data.id){
								if(that.lists.length > 0){
									if(res.data.id != that.lists[that.lists.length - 1].id){
										that.lastId = res.data.id
										that.lists = [...that.lists,...[res.data]];
									}
								}else{
									that.lastId = res.data.id
									that.lists = [...that.lists,...[res.data]];
								}
								
							}
							
						}else{
							that.$message.error(res.msg);
						}
					})
				}else{
					this.$message.error('Please enter a message!');
				}
				
			}
		}
	}
</script>
<style scoped>
	@import url("../../assets/css/message.css");
</style>
